// ALT-PDP-AVATAR-001: toggles [data-avatar] content blocks across separate
// PDP sections (product-process, and any future avatar-aware section) when
// the Line variant (Signature / Comfort Fit) changes. Reuses Dawn's existing
// global pubsub (subscribe/publish/PUB_SUB_EVENTS from pubsub.js/constants.js,
// already loaded site-wide in layout/theme.liquid) instead of a parallel event
// system. No network request: the resolved variant already arrives on the
// existing variant-change event payload.
//
// Filename note: this file was originally `pdp-avatar-toggle.js`. Renamed to
// force a fresh CDN URL after the storefront CDN kept serving a stale cached
// build under the old URL's `?v=` fingerprint across multiple content pushes
// -- see ALT-PDP-AVATAR-001 for the full diagnosis. Do not rename again
// without a reason; each rename forces every consuming section to update its
// <script src> reference.
if (!window.__pdpAvatarToggleInit) {
  window.__pdpAvatarToggleInit = true;

  // `data-option-name` already exists on every option <input>, rendered by
  // the pre-existing snippets/product-variant-options.liquid for its own
  // purposes -- discovered live when an earlier version of this file added
  // the SAME attribute name to the wrapping <fieldset> too, which made
  // `[data-option-name]` match both levels and miscount option positions.
  // Reuses the existing per-input attribute instead of introducing a new
  // one; scoped to `input` so it only reads the per-value attribute.
  function pdpAvatarFromVariant(variant, sectionId) {
    if (!variant || !Array.isArray(variant.options)) return null;

    const variantSelects = sectionId
      ? document.getElementById('variant-selects-' + sectionId)
      : document.querySelector('variant-selects');
    if (!variantSelects) return null;

    const seenNames = [];
    variantSelects.querySelectorAll('input[data-option-name]').forEach((el) => {
      const name = el.dataset.optionName;
      if (name && seenNames.indexOf(name) === -1) seenNames.push(name);
    });

    const lineIndex = seenNames.findIndex((name) => name.trim().toLowerCase() === 'line');  // data-option-name is a locale-proof key (alt-option-key.liquid)
    if (lineIndex === -1) return null;

    return pdpAvatarFromLineValue(variant.options[lineIndex]);
  }

  // The Line option values on the live store are "Made to Order" (Signature)
  // and "Made to Measure" (Comfort Fit). Legacy "Standard Fit" is still
  // honoured. The old mapper had no "made to order" branch, so once a size
  // was picked the Signature copy never replaced the Comfort Fit copy.
  function pdpAvatarFromLineValue(value) {
    const lineValue = (value || '').trim().toLowerCase();
    // English or Spanish spelling (the Spanish storefront returns translated values).
    if (lineValue.includes('made to measure') || lineValue.includes('a medida')) return 'comfort-fit';
    if (lineValue === 'made to order' || lineValue === 'standard fit' || lineValue.includes('por encargo') || lineValue.includes('a pedido')) return 'signature';
    if (lineValue.includes('standard')) return 'signature';
    return null;
  }

  function applyPdpAvatar(avatar) {
    document.querySelectorAll('[data-avatar]').forEach((el) => {
      el.hidden = el.dataset.avatar !== avatar;
    });
  }

  // Switch the copy the moment the shopper picks a Line card, before a size
  // is chosen and a full variant resolves.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || !input.matches || !input.matches('input[data-option-name]')) return;
    if ((input.dataset.optionName || '').trim().toLowerCase() !== 'line') return;
    if (!input.checked) return;
    const avatar = pdpAvatarFromLineValue(input.value);
    if (avatar) applyPdpAvatar(avatar);
  });

  function registerVariantChangeSubscriber() {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const avatar = pdpAvatarFromVariant(data.variant, data.sectionId);
      if (avatar) applyPdpAvatar(avatar);
    });
  }

  if (document.readyState === 'complete') {
    registerVariantChangeSubscriber();
  } else {
    window.addEventListener('load', registerVariantChangeSubscriber, { once: true });
  }
}
